import { useNavigate } from 'react-router-dom';
import { Button } from 'tdesign-react';

import { IBot } from '@/interface';
import { getMediaUrlValue } from '@/material/form-upload/change-data';
import { CREATE_BOT_INFO } from '@/router/const';

import styles from './index.module.less';

interface IProps {
  item: IBot;
  showBtn?: boolean;
}

const BotCard: React.FC<IProps> = (props) => {
  const { item, showBtn = true } = props;
  const bgUrl = getMediaUrlValue(item?.addUserBackground);
  const avaUrl = getMediaUrlValue(item?.avatar);
  const forUrl = getMediaUrlValue(item?.addUserForeBackground) || avaUrl;
  const avaColor = item?.avatar?.sample?.primary;
  const bgPrimaryColor = item?.addUserBackground?.sample?.primary || avaColor;

  const navigator = useNavigate();
  const getToCreateBot = () => {
    navigator(`${CREATE_BOT_INFO}/${item?.id}`);
  };

  return (
    <div className={styles.botWrapper}>
      <div className={styles.hoverBox}>
        <div
          className={styles.box}
          style={{
            backgroundImage: bgUrl ? `url(${bgUrl})` : avaColor || '',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <img src={forUrl} alt="" className={styles.forImage} />
          <div
            className={styles.desc}
            style={{
              background: `linear-gradient(179.9deg, rgba(236, 193, 79, 0) 58.28%, ${bgPrimaryColor} 82.7%, ${bgPrimaryColor} 100%)`,
            }}
          >
            <div className={styles.info}>
              <div className={styles.name}>{item?.name}</div>
              <div className={styles.intro}>{item?.intro}</div>
            </div>
          </div>
        </div>
        {showBtn && <div className={styles.createBtnMask} onClick={getToCreateBot}>
          <Button variant="outline" ghost className={styles.btn}>
            去创作
          </Button>
        </div>}
      </div>
    </div>
  );
};

export default BotCard;
